import { apiFormRequest, apiRequest } from "@/apis/client";
import type {
  VideoItem,
  VideoPayload,
  VideoThumbnailUploadResponse,
  VideoUploadResponse,
} from "@/apis/types";

export const videosApi = {
  listForUser(): Promise<VideoItem[]> {
    return apiRequest<VideoItem[]>("/videos");
  },

  listAll(): Promise<VideoItem[]> {
    return apiRequest<VideoItem[]>("/admin/videos");
  },

  create(payload: VideoPayload): Promise<VideoItem> {
    return apiRequest<VideoItem>("/admin/videos", "POST", payload);
  },

  update(id: string, payload: VideoPayload): Promise<VideoItem> {
    return apiRequest<VideoItem>(`/admin/videos/${encodeURIComponent(id)}`, "PUT", payload);
  },

  remove(id: string): Promise<void> {
    return apiRequest<void>(`/admin/videos/${encodeURIComponent(id)}`, "DELETE");
  },

  async uploadVideo(file: File): Promise<VideoUploadResponse> {
    const ticket = await apiRequest<VideoUploadResponse>("/admin/videos/upload", "POST", {
      filename: file.name,
      contentType: file.type || "video/mp4",
      size: file.size,
    });
    const upload = await fetch(ticket.upload_url, {
      method: "PUT",
      headers: { "Content-Type": ticket.content_type },
      body: file,
    });
    if (!upload.ok) {
      throw new Error("Failed to upload video");
    }
    return ticket;
  },

  uploadThumbnail(file: File): Promise<VideoThumbnailUploadResponse> {
    const formData = new FormData();
    formData.append("file", file);
    return apiFormRequest<VideoThumbnailUploadResponse>(
      "/admin/videos/upload-thumbnail",
      formData,
      "POST"
    );
  },
};
